export function onlyLotin(str) {
    if (!str) return false
    let arr = str.split("")
    return arr.every(el => {
        if (!!el.match(/^[a-z ]*$/i) || el == '\`' || el == '\'' || el == '\‘' || el == '\’' || el == 'Á' || el == 'Ú' || el == 'Ń' || el == 'Í' || el == 'Ó' || el == 'Ǵ' || el == 'W' || el == '-') {
            return true
        }
        return false
    });
}

export function hasNotCrilic(st) {
    if (!st) return true
    const cyrillicPattern = /[а-яА-ЯЁё]/;
    return !cyrillicPattern.test(st)
}

export function hasNotNumber(st) {
    if (!st) return true
    const numberPattern = /^\d+$/;
    return !numberPattern.test(st)
}